export const GET_THEMES_CLIENT_CALL = 'GET_THEMES_CLIENT_CALL';
export const GET_THEMES_CLIENT_DONE = 'GET_THEMES_CLIENT_DONE';
export const GET_THEMES_CLIENT_FAIL = 'GET_THEMES_CLIENT_FAIL';
